module.exports = __webpack_public_path__ + "static/media/harvardLogo.ca70a1df.png";